import React from "react";
import { useRestaurantConfig } from "../../utils/restaurantConfig";
import { formatDateTimeInTimezone } from "../../utils/dateTimeUtils";

const IncomingRequestsModal = ({
  open,
  onClose,
  requests,
  loading,
  onAccept,
  onReject,
}) => {
  const { timezone } = useRestaurantConfig();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto mx-4">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-teal-600 to-teal-700 px-6 py-4 flex justify-between items-center rounded-t-xl shadow-md">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            Incoming QR Requests
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-teal-100 transition-colors p-1 hover:bg-white/20 rounded-lg"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {loading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-teal-200 border-t-teal-600"></div>
              <p className="text-gray-600 mt-3">Loading...</p>
            </div>
          ) : requests.length === 0 ? (
            <p className="text-center text-gray-500 py-8">
              No incoming requests
            </p>
          ) : (
            <div className="space-y-3">
              {requests.map((r) => (
                <div
                  key={r._id}
                  className="border border-gray-200 rounded-lg p-4 flex justify-between items-start gap-4 hover:shadow-md transition-shadow"
                >
                  {/* Left: Details */}
                  <div className="flex-1">
                    <div className="font-semibold text-gray-800 text-lg mb-2">
                      Table {r.tableId?.tableNumber}
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p>
                        <span className="font-medium">Name:</span> {r.name}
                      </p>
                      <p>
                        <span className="font-medium">Guests:</span>{" "}
                        {r.customerCount}
                      </p>
                      <p className="text-xs text-gray-500 mt-2">
                        {formatDateTimeInTimezone(r.createdAt, timezone)}
                      </p>
                    </div>
                  </div>

                  {/* Right: Actions */}
                  <div className="flex flex-col gap-2">
                    <button
                      onClick={() => onAccept(r)}
                      className="px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all"
                    >
                      Accept
                    </button>
                    <button
                      onClick={() => onReject(r._id)}
                      className="px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IncomingRequestsModal;
